import { useRequiredContext } from "@redotech/react-util/context";
import SaleIcon from "@redotech/redo-icons/sale-03.svg";
import SaleFilledIcon from "@redotech/redo-icons/sale-03_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useMatch } from "react-router-dom";

export const DiscountRulesItems = memo(function DiscountRulesItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const href = routes.getConversionSubRoute("discount-rules");
  const match = useMatch({ path: href, end: false });

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href }}
      FilledIcon={SaleFilledIcon}
      friendlyName="Discount rules"
      id="discount-rules"
      selected={!!match}
      UnfilledIcon={SaleIcon}
    />
  );
});
